export default {
  paginaAtual: 1,
  estaCarregando: false,
  order: '',
  direcao: '',
  todosItensCarregados: false,
  totalItens: null,
  listaFranqueada: [],
  franqueadaSelecionadaId: null,
  objFranqueada: {
    nome: '',
    cnpj: '',
    cpf: '',
    dias_em_abertos_movimentos: '',
    dias_lembrete_cobranca: '',
    sabado_dia_util: '',
    desconto_super_amigos_ativo: true,
    desconto_super_amigos_turbinado_ativo: true,
    razao_social: '',
    endereco: '',
    numero_endereco: '',
    bairro_endereco: '',
    complemento_endereco: '',
    cep_endereco: '',
    estado: null,
    cidade: null,
    inscricao_estadual: '',
    telefone: '',
    telefone_secundario: '',
    email: '',
    email_direcao: '',
    email_comercial: '',
    desconto_super_amigos: '',
    desconto_super_amigos_turbinado: '',
    valor_desconto_avista: '',
    percentual_juro_dia: '',
    percentual_multa: '',
    tolerancia_inadimplencia: 0,
    tipo_movimento_conta_receber: null,
    tipo_movimento_conta_pagar: null,
    situacao: '',
    limite_dias_alteracao_documento: '',
    percentual_desconto_a_vista: null
  }
}
